module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_Meshes_mesh_vertexData__;